import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 8px;
  width: 100%;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .section-title {
    font-family: ManropeBold, sans-serif;
    font-size: 13px;
    color: ${(props) => props.theme.colors.inactive};
  }

  .fleets {
    display: flex;
    flex-direction: column;
    gap: 4px;

    &.scrollable {
      max-height: 320px;
      overflow-y: auto;
    }

    &::-webkit-scrollbar {
      width: 12px;
    }

    &::-webkit-scrollbar-track {
      background: ${(props) => props.theme.colors.background_dashboard};
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${(props) => props.theme.colors.inactive};
      border-radius: 20px;
      border: 3px solid ${(props) => props.theme.colors.background_dashboard};
    }
  }

  .message {
    font-family: ManropeLight, sans-serif;
    font-size: 13px;
    font-style: italic;
    padding: 8px 0;
    color: ${(props) => props.theme.colors.inactive};

    &.error {
      color: ${(props) => props.theme.colors.orange};
    }
  }
`;

const FleetItem = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 12px;
  border-radius: 6px;
  cursor: pointer;
  text-align: left;
  background: ${(props) => props.theme.colors.widget_background};
  color: ${(props) => props.theme.colors.text};

  .name {
    font-family: ManropeBold, sans-serif;
    font-size: 13px;
    max-width: 260px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .organization {
    font-family: ManropeRegular, sans-serif;
    font-size: 13px;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${(props) => props.theme.colors.inactive};
  }

  .badge {
    margin-left: auto;
    font-family: ManropeRegular, sans-serif;
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 10px;
    background: ${(props) => props.theme.colors.main_cta_light};
    color: ${(props) => props.theme.colors.main_cta};
  }

  &.active {
    outline: 1px solid ${(props) => props.theme.colors.main_cta};
  }

  &:hover {
    background: ${(props) => props.theme.colors.widget_hover_background};
    transition: all .2s ease-in;
  }
`;

export default { Wrapper, Section, FleetItem };
